import { publish } from '../..';
import { ICallback } from '../../models';

type TCallbackGroup = Record<string, ICallback[]>;

type TCallbackFunction = (data: unknown) => void;

/**
 * Группирует колбеки по их пропам-ключам
 *
 * @param callbacks - колбеки
 */
export const groupByPropKey = (callbacks: ICallback[]) =>
    callbacks.reduce<TCallbackGroup>((result, callback) => {
        const { propKey } = callback;
        const prevCallback = result[propKey] ?? [];

        return {
            ...result,
            [propKey]: [...prevCallback, callback],
        };
    }, {});

const publishEventPayload = (handlers: ICallback[], data: unknown) => {
    handlers.forEach(({ event, payload }) =>
        publish(event, payload === undefined ? data : payload)
    );
};

/**
 * Добавляет публикацию ивентов в пропсы дочернего компонента по ключам, указанным в сгруппированных колбеках
 *
 * @param callbacks - сгруппированные колбеки
 * @param childProps - пропсы дочернего компонента
 */
export const injectPublishEvents = (
    callbacks: TCallbackGroup,
    childProps: Record<string, unknown>
) => {
    const propsArr = Object.entries(callbacks).map(([propKey, handlers]) => [
        propKey,
        (data: unknown) => {
            if (typeof childProps[propKey] === 'function') {
                (childProps[propKey] as TCallbackFunction)(data);
            }

            publishEventPayload(handlers, data);
        },
    ]);

    return Object.fromEntries(propsArr);
};
